export default "/images/AggregoOncology.png?cf4a4f5a7ac014f342b8af28a9816fd5";